import React from 'react';

type FileSVGProps = {
  viewBox?: string;
  path: string;
  className?: string;
  fill?: string;
} & React.SVGProps<SVGSVGElement>;

const FileSVG: React.FC<FileSVGProps> = ( { viewBox = '0 0 24 24', path, className, fill, ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      className={className}
      fill={fill}
      width="100%"
      height="100%"
      style={{ display: 'block' }}
      {...props}
    >
      <path d={path} />
    </svg>
  );
};

export { FileSVG };
